function offerAlreadyIncludesProduct(product: string, offer: string) {
  const normalizedProduct = product.toLowerCase();
  const normalizedOffer = offer.toLowerCase();

  if (normalizedOffer === normalizedProduct) return true;
  if (normalizedOffer.startsWith(`${normalizedProduct} –`)) return true;
  if (normalizedOffer.startsWith(`${normalizedProduct} -`)) return true;
  if (normalizedOffer.startsWith(`${normalizedProduct}–`)) return true;
  if (normalizedOffer.startsWith(`${normalizedProduct}-`)) return true;

  return false;
}

export function formatCheckoutDisplayName(
  productName?: string | null,
  offerName?: string | null,
) {
  const product = productName?.trim() ?? '';
  const offer = offerName?.trim() ?? '';

  if (product && offer) {
    if (offerAlreadyIncludesProduct(product, offer)) return offer;
    return `${product} – ${offer}`;
  }

  return product || offer;
}
